import React from 'react';
import ForgotUserNameSentConfirmation from "../../components/forgot-user-name/ForgotUserNameSentConfirmation";

const ForgotUserNameSent = (props) => (
    <ForgotUserNameSentConfirmation {...props} />
);

export default ForgotUserNameSent;